import React, { useState } from "react";
import { formatCaseId } from "../../client/dashboard/casesApi";
import MaterialIcon from "./MaterialIcon";

/**
 * Displays the public case reference with optional copy-to-clipboard.
 */
const CaseIdBadge = ({ caseData, className = "", showCopy = true, variant = "default" }) => {
  const label = formatCaseId(caseData);
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!label || label === "—") return;
    try {
      await navigator.clipboard.writeText(label);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  if (variant === "enterprise") {
    return (
      <div className={["flex items-center gap-2", className].join(" ")}>
        <span className="font-label-caps text-secondary">{label}</span>
        {showCopy && label !== "—" ? (
          <button
            type="button"
            onClick={handleCopy}
            className="text-on-surface-variant transition-colors hover:text-primary"
            title={copied ? "Copied" : "Copy case ID"}
          >
            <MaterialIcon name={copied ? "check" : "content_copy"} className="text-sm" />
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <span
      className={[
        "inline-flex shrink-0 flex-nowrap items-center gap-1.5 whitespace-nowrap font-mono text-[12px] font-semibold tracking-tight text-[#006666]",
        className,
      ].join(" ")}
    >
      <span className="whitespace-nowrap" title="Case-ID">
        {label}
      </span>
      {showCopy && label !== "—" ? (
        <button
          type="button"
          onClick={handleCopy}
          className="shrink-0 whitespace-nowrap rounded px-1 py-0.5 text-[10px] font-sans font-medium uppercase tracking-wide text-[#64748b] hover:bg-[#e6f4f4] hover:text-[#006666]"
          title="Case-ID kopieren"
        >
          {copied ? "Kopiert" : "Kopieren"}
        </button>
      ) : null}
    </span>
  );
};

export default CaseIdBadge;
